
const GLOBAL_SCROLL_WIDTH = 10;
const GLOBAL_SCROLL_HEIGHT = 10;

export { GLOBAL_SCROLL_WIDTH, GLOBAL_SCROLL_HEIGHT };
